import { useMemo } from "react";
import type { ScaleLinear } from "d3";
import { formatPrice } from "@/lib/formatters";

type AxisLeftProps = {
  yScale: ScaleLinear<number, number>;
  pixelsPerTick: number;
  width: number;
};

const TICK_LENGTH = 6;

export const AxisLeft = ({ yScale, pixelsPerTick, width }: AxisLeftProps) => {
  const range = yScale.range();

  const ticks = useMemo(() => {
    const height = range[0] - range[1];
    const numberOfTicksTarget = Math.floor(height / pixelsPerTick);

    return yScale.ticks(numberOfTicksTarget).map((value) => ({
      value,
      yOffset: yScale(value),
    }));
  }, [pixelsPerTick, range, yScale]);

  return (
    <>
      {/* Ticks and labels */}
      {ticks.map(({ value, yOffset }) => (
        <g key={value} transform={`translate(0, ${yOffset})`} shapeRendering={"crispEdges"}>
          <line
            className="stroke-border"
            x1={-TICK_LENGTH}
            x2={width + TICK_LENGTH}
            stroke="current"
            strokeWidth={0.5}
          />
          <text
            key={value}
            className="-translate-x-3 translate-y-1 fill-muted-foreground text-xs"
            style={{
              textAnchor: "end",
            }}
          >
            {formatPrice(value)}
          </text>
        </g>
      ))}
    </>
  );
};
